import { render } from "./IconSpinner.vue?vue&type=template&id=0bfdedca&scoped=true"
const script = {}

import "./IconSpinner.vue?vue&type=style&index=0&id=0bfdedca&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfdedca"]])

export default __exports__